
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from "vue-property-decorator";
import HazardListItem from "../components/HazardListItem.vue";
import MapTile from "../components/MapTile.vue";
import QrCode from "../components/QRCode.vue";

@Component({
  components: {
    HazardListItem,
    MapTile,
    QrCode
  }
})
export default class HazardListScreen extends Vue {
  @Prop({})
  hazardSiteList!: any;
  @Prop({})
  hazardRouteList!: any;
  @Prop({})
  defaultLocationList!: any;
  @Prop({})
  selectedLocation!: any;
  @Prop({})
  accuracy!: number;
  @Prop({})
  noti!: number;
  @Prop({})
  route!: number[][];
  @Prop({})
  trackPath!: number[][];
  @Prop({})
  endCoords!: number[];
  @Prop({})
  otherTracks!: number[][];
  @Prop({})
  accessPoints!: number[][];
  @Prop({})
  difibrillators!: number[][];

  private mapLoaded() {
    this.$emit("map-loaded");
  }
}
